export const BUSINESS = {
  name: "Prosper Garage Door Repair",
  shortName: "Prosper Garage Door",
  phoneDisplay: "(972) 742-3944",
  phoneRaw: "+19727423944",
  email: "Prospergaragedoors@gmail.com",
  address: "130 N Preston Rd, Prosper, TX 75078",
  hours: "Open 24 Hours / 7 Days",
  tagline: "24/7 Emergency Garage Door Repair in Prosper, TX",
};

// `verified: true` = confirmed real account (shown in footer + schema sameAs).
// Unverified entries are kept here ready to enable once the client confirms the real URL.
export const SOCIALS = [
  { name: "Facebook", url: "https://www.facebook.com/prospergaragedoorrepair", icon: "Facebook", verified: true },
  { name: "Instagram", url: "https://www.instagram.com/prospergaragedoor/", icon: "Instagram", verified: true },
  { name: "X", url: "https://x.com/ProsperGarage", icon: "Twitter", verified: true },
  { name: "YouTube", url: "https://www.youtube.com/@ProsperGarageDoorRepair", icon: "Youtube", verified: true },
  { name: "LinkedIn", url: "https://www.linkedin.com/company/prosper-garage-door/", icon: "Linkedin", verified: true },
  { name: "TikTok", url: "https://www.tiktok.com/@prospergaragedoor", icon: "TikTok", verified: true },
];

// Only confirmed-real accounts — use these for public links + SEO sameAs.
export const VERIFIED_SOCIALS = SOCIALS.filter((s) => s.verified);

// Google review generation. GBP reinstatement pending — once the Google Business
// Profile is verified, set enabled:true and paste the real "Write a review" short
// link (format: https://g.page/r/XXXX/review OR
// https://search.google.com/local/writereview?placeid=PLACE_ID). Flipping enabled
// shows the public "Leave a Google Review" button and finalizes the admin template.
export const GOOGLE_REVIEW = {
  enabled: true,
  url: "https://g.page/r/CXGep-YOqLy8EAI/review",
};

// Pre-written review-request SMS the owner can send to happy customers.
export const reviewRequestMessage = (name = "") =>
  `Hi${name ? " " + name.trim().split(" ")[0] : ""}, thanks for choosing Prosper Garage Door Repair! ` +
  `If you were happy with our service, would you take 30 seconds to leave us a quick Google review? ` +
  `It genuinely helps our local family business: ${GOOGLE_REVIEW.url}`;

export const SERVICE_AREAS = [
  "Prosper",
  "Celina",
  "Frisco",
  "Aubrey",
  "McKinney",
  "Melissa",
  "Anna",
  "Collin County",
];

export const SERVICES = [
  {
    icon: "Coil",
    title: "Garage Door Spring Repair",
    desc: "Snapped torsion or extension spring? We replace high-cycle springs fast so your door is safe and balanced again.",
  },
  {
    icon: "Settings",
    title: "Garage Door Opener Repair",
    desc: "Repair or upgrade noisy, unresponsive openers — including smart Wi-Fi openers for LiftMaster, Chamberlain & more.",
  },
  {
    icon: "AlignHorizontalDistributeCenter",
    title: "Off-Track Garage Door Repair",
    desc: "Door jumped the track or won't move? We realign rollers, tracks and cables and get you back on track.",
  },
  {
    icon: "LayoutPanelLeft",
    title: "Garage Door Panel Replacement",
    desc: "Dented or damaged panels replaced to restore curb appeal and full structural strength of your door.",
  },
  {
    icon: "DoorOpen",
    title: "New Garage Door Installation",
    desc: "Beautiful, energy-efficient new garage doors professionally installed with a workmanship warranty.",
  },
  {
    icon: "Siren",
    title: "24/7 Emergency Garage Door Repair",
    desc: "Car stuck inside? Door won't close at night? We answer around the clock with same-day emergency service.",
  },
  {
    icon: "ShieldAlert",
    title: "Garage Door Won't Close Repair",
    desc: "Door reversing, stopping short, or refusing to close? We realign safety sensors, adjust limits and fix the root cause fast.",
  },
  {
    icon: "Cable",
    title: "Garage Door Cable Repair & Replacement",
    desc: "Frayed, loose or snapped lift cables — or a cable off the drum? We replace cables and rebalance the door safely.",
  },
  {
    icon: "CircleDot",
    title: "Garage Door Roller Replacement",
    desc: "Noisy, cracked or worn rollers make your door grind and bind. We swap them for smooth, quiet long-life rollers.",
  },
  {
    icon: "KeyRound",
    title: "Garage Door Remote & Keypad Programming",
    desc: "New remote, keypad or in-car (HomeLink) button not working? We program and sync your openers so everything works again.",
  },
];

export const WHY_US = [
  {
    icon: "Clock",
    title: "24/7 Availability",
    desc: "Day or night, we pick up the phone and dispatch a local tech.",
  },
  {
    icon: "Zap",
    title: "Same-Day Service",
    desc: "Fast arrival across Prosper & Collin County — most repairs done in one visit.",
  },
  {
    icon: "ShieldCheck",
    title: "Licensed & Insured",
    desc: "Trained, background-checked technicians and fully insured work.",
  },
  {
    icon: "BadgeCheck",
    title: "Upfront Pricing",
    desc: "Honest, written quotes before we start. No surprises, no hidden fees.",
  },
];

export const PROCESS = [
  { step: "01", title: "Call or Request a Quote", desc: "Tell us what's wrong — by phone or our quick form." },
  { step: "02", title: "Same-Day Diagnosis", desc: "A local tech arrives and gives you upfront pricing." },
  { step: "03", title: "Fast, Lasting Repair", desc: "We fix it right the first time, backed by our warranty." },
];

// Real customer reviews migrated from the company's Trustpilot (via prosperdoors.com).
export const REVIEW_SOURCE = "Trustpilot";
export const REVIEW_RATING = "5.0";
export const TESTIMONIALS = [
  {
    name: "Richard C. Marshall",
    location: "Verified Trustpilot Review",
    text: "Awesome service, up front price, and Scott is the guy that answers the phone and repairs the door. Probably the best home contractor experience I've ever had, and I'm in my 60s. 10/10",
    rating: 5,
  },
  {
    name: "Jennifer J. O'Neal",
    location: "Verified Trustpilot Review",
    text: "Easy to understand the quote. Fixed pricing with zero gotchas. Everything went to plan in the time frame he stated. Completely retuned the garage door to new. No issues or worries. Will recommend and use again.",
    rating: 5,
  },
  {
    name: "Jeremy Swindell",
    location: "Verified Trustpilot Review",
    text: "Scott with Prosper Garage Doors is awesome! Showed up on time, very professional and fixed our garage door quickly. Thank you Scott!!!!",
    rating: 5,
  },
  {
    name: "Jeremy F.",
    location: "Verified Trustpilot Review",
    text: "Called to make an appointment and Arturo came out right away. He is very professional, knowledgeable and I was very satisfied with the work and price. I would highly recommend Arturo.",
    rating: 5,
  },
  {
    name: "Naami London",
    location: "Verified Trustpilot Review",
    text: "Prosper Garage Doors is an amazing company. Fast and efficient service. Would definitely recommend this company. 10/10",
    rating: 5,
  },
  {
    name: "Keenan Alistair",
    location: "Verified Trustpilot Review",
    text: "We are extremely happy with the repairs to our garage door by Prosper Garage Doors. He was very informative, helpful, honest, not to mention that the work was fairly priced.",
    rating: 5,
  },
  {
    name: "Greg Chappell",
    location: "Verified Trustpilot Review",
    text: "Excellent job repairing our garage door. Fair price, quality work, and timely service. Honest and reliable business. Highly recommend. Thank you.",
    rating: 5,
  },
  {
    name: "Gareme Watson",
    location: "Verified Trustpilot Review",
    text: "Prosper Garage Doors provide excellent service! Professional, timely, and fair pricing. I will be recommending to all who need garage repair or replacement. This company is really worth appreciation.",
    rating: 5,
  },
  {
    name: "Chris Morris",
    location: "Verified Trustpilot Review",
    text: "He is real nice and professional. He explained everything he was doing and treated us really well. I would recommend him to anyone needing a new garage door, opener, or just a tune-up or repair.",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "Do you really offer 24/7 emergency service?",
    a: "Yes. Garage doors break at the worst times. We answer calls around the clock and dispatch a local technician for true emergencies like a door that won't close or a car trapped inside.",
  },
  {
    q: "How fast can you get to me?",
    a: "We serve Prosper, Celina, Frisco, McKinney and the rest of Collin County. In most cases we offer same-day service and can arrive within a couple of hours for emergencies.",
  },
  {
    q: "How much does a typical repair cost?",
    a: "Every job is different, but we always provide upfront, written pricing before any work begins. No hidden fees and no pressure.",
  },
  {
    q: "Do you replace springs and cables?",
    a: "Absolutely. Broken springs and frayed cables are our most common calls. We use high-cycle parts and balance the door so it lasts.",
  },
  {
    q: "Is your work guaranteed?",
    a: "Yes — our technicians are licensed and insured, and our repairs and installations are backed by a workmanship warranty.",
  },
  {
    q: "How long does a garage door spring last?",
    a: "Standard springs are rated for about 10,000 cycles — roughly 7 years of typical use. Texas heat, rust and missed lubrication shorten that, which is why we offer longer-lasting high-cycle springs.",
  },
  {
    q: "Do you offer same-day garage door repair near me?",
    a: "Yes. We're based in Prosper and serve all of Collin County with same-day service, and 24/7 dispatch for emergencies like a door that won't close.",
  },
  {
    q: "What garage door brands do you work on?",
    a: "All major brands and door types — steel, insulated, carriage-style, wood and custom doors — plus openers from LiftMaster, Chamberlain, Genie and more.",
  },
  {
    q: "What garage door problems do you fix most often?",
    a: "We handle every common issue. If you searched garage door repair near me or need emergency garage door repair, we're ready 24/7. Frequent jobs include a broken garage spring, a garage door won't close problem, a garage door cable off the drum, a garage door off track, garage door opener repair, garage door spring replacement, garage door roller replacement, garage door remote programming, and garage door panel repair.",
  },
];
